module.exports = "<div id=\"preloader\"><div id=\"loader\"></div></div>\r\n"